module.exports = __webpack_public_path__ + "rt-s2.png?619278e1812e3aba69cba83a7f734f08";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rt-s2.png
// module id = 58
// module chunks = 0